import { call } from '../actions/index.js';
/**
 * Method to get a quote for a call action
 * @param data - {@link GetCallQuoteParameters}
 */
export async function getCallQuote(data) {
    const result = await call({
        ...data,
        precheck: true
    });
    return result;
}
//# sourceMappingURL=getCallQuote.js.map